const topViewPaper = Raphael(
  "top-view",
  document.getElementById("top-view").offsetWidth,
  document.getElementById("top-view").offsetHeight)
const sideViewPaper = Raphael(
  "side-view", 
  document.getElementById("side-view").offsetWidth, 
  document.getElementById("side-view").offsetHeight)

export async function drawAnchorDiagramTopView(anchorDesignAdapter) {

  let paper = topViewPaper

  paper.clear()

  const canvasW = document.getElementById("top-view").offsetWidth
  const canvasH = document.getElementById("top-view").offsetHeight
  const canvasRect = [canvasW, canvasH]
  //const scale = getScale(anchorDesignAdapter, canvasRect)
  
  const anchorBlockWidth = anchorDesignAdapter.blockWidth
  const anchorBlockHeight = anchorDesignAdapter.blockHeight
  const anchorBlockThickness = anchorDesignAdapter.concrete.concreteThickness
  const scale1 = getScale(anchorBlockWidth, anchorBlockHeight, canvasRect)
  const scale2 = getScale(anchorBlockWidth, anchorBlockThickness, canvasRect)
  const scale = Math.min(scale1, scale2)
  
  var st = paper.set()

  // draw the block
  st.push(paper.rect(0, 0, anchorBlockWidth * scale, anchorBlockHeight * scale).attr("stroke-width", 2))

  //draw the bolts
  const colSpacing = anchorDesignAdapter.geometry.columnSpacing
  const rowSpacing = anchorDesignAdapter.geometry.rowSpacing
  const boltDiameter = anchorDesignAdapter.boltAndNut.boltDiameter
  for (let column = 0; column < anchorDesignAdapter.geometry.nColumns; column++) {
    for (let row = 0; row < anchorDesignAdapter.geometry.nRows; row++) {
      let c = paper.circle(
        column * colSpacing * scale,
        row * rowSpacing * scale,
        boltDiameter * 0.5 * scale).translate(
          anchorDesignAdapter.geometry.leftEdge * scale,
          anchorDesignAdapter.geometry.topEdge * scale)
        c.attr("stroke-width", 2),
      st.push(c)
    }
  }

  // width label
  let x1 = 0
  let y1 = anchorBlockHeight * scale + 10 
  let x2 = anchorBlockWidth * scale 
  let y2 = y1
  st.push(drawHorizontalDoubleArrow(x1, y1, x2, y2, 10, paper))
  let str = `${anchorBlockWidth} in`  
  st.push(drawLabelForHorizontalDimension(str, x1, x2, y1, 12, paper))

  // height label
  x1 = -10
  y1 = 0
  x2 = x1
  y2 = anchorBlockHeight * scale  
  st.push(drawVerticalDoubleArrow(x1, y1, x2, y2, 10, paper))
  str = `${anchorBlockHeight} in`  
  st.push(drawLabelForVerticalDimension(str, x1, y1, y2, 'left', 12, paper))

  // left edge label
  x1 = 0
  y1 = anchorDesignAdapter.geometry.topEdge * scale
  x2 = anchorDesignAdapter.geometry.leftEdge * scale
  y2 = y1
  st.push(drawHorizontalDoubleArrow(x1, y1, x2, y2, 10, paper))
  str = `${anchorDesignAdapter.geometry.leftEdge} in`  
  st.push(drawLabelForHorizontalDimension(str, x1, x2, y1, 12, paper))

  // right edge label
  x1 = (anchorBlockWidth - anchorDesignAdapter.geometry.rightEdge) * scale
  y1 = anchorDesignAdapter.geometry.topEdge * scale
  x2 = x1 + anchorDesignAdapter.geometry.rightEdge * scale
  y2 = y1
  st.push(drawHorizontalDoubleArrow(x1, y1, x2, y2, 10, paper))
  str = `${anchorDesignAdapter.geometry.rightEdge} in`  
  st.push(drawLabelForHorizontalDimension(str, x1, x2, y1, 12, paper))

  // top edge label
  x1 = anchorDesignAdapter.geometry.leftEdge * scale
  y1 = 0
  x2 = x1
  y2 = anchorDesignAdapter.geometry.topEdge * scale  
  st.push(drawVerticalDoubleArrow(x1, y1, x2, y2, 10, paper))
  str = `${anchorDesignAdapter.geometry.topEdge} in`  
  st.push(drawLabelForVerticalDimension(str, x1, y1, y2, 'center', 12, paper))


  // bottom edge label
  x1 = anchorDesignAdapter.geometry.leftEdge * scale
  y1 = (anchorBlockHeight - anchorDesignAdapter.geometry.bottomEdge) * scale
  x2 = x1
  y2 = anchorBlockHeight * scale
  st.push(drawVerticalDoubleArrow(x1, y1, x2, y2, 10, paper))
  str = `${anchorDesignAdapter.geometry.bottomEdge} in`  
  st.push(drawLabelForVerticalDimension(str, x1, y1, y2, 'center', 12, paper))

  // row spacing label
  if(anchorDesignAdapter.geometry.nRows > 1) {
    x1 = anchorDesignAdapter.geometry.leftEdge * scale
    y1 = anchorDesignAdapter.geometry.topEdge * scale
    x2 = x1
    y2 = anchorDesignAdapter.geometry.topEdge * scale + anchorDesignAdapter.geometry.rowSpacing * scale
    st.push(drawVerticalDoubleArrow(x1, y1, x2, y2, 10, paper))
    str = `${anchorDesignAdapter.geometry.rowSpacing} in`  
    st.push(drawLabelForVerticalDimension(str, x1, y1, y2, 'center', 12, paper))
  }

  // column spacing label

  // bolt diameter
  x1 = anchorDesignAdapter.geometry.leftEdge * scale + (anchorDesignAdapter.geometry.nColumns > 1 ? anchorDesignAdapter.geometry.columnSpacing * scale : 0)
  y1 = anchorDesignAdapter.geometry.topEdge * scale
  st.push(drawDiameterArrow(x1, y1, 10, paper))
  str = anchorDesignAdapter.boltAndNut.boltDiameterLabel
  st.push(drawLabelForDiameterDimension(str, x1, y1, 10, 12, paper))

  const center = [canvasRect[0] * 0.5, canvasRect[1] * 0.5]
  const blockLeftEdge = center[0] - anchorBlockWidth * scale * 0.5
  const blockTopEdge = center[1] - anchorBlockHeight * scale * 0.5

  st.translate(blockLeftEdge, blockTopEdge)
}

export async function drawAnchorDiagramSideView(anchorDesignAdapter) {

  let paper = sideViewPaper

  paper.clear()

  let canvasW = document.getElementById("side-view").offsetWidth
  // use top-view here. not a typo, we want the view heights to match
  let canvasH = document.getElementById("top-view").offsetHeight
  let canvasRect = [canvasW, canvasH]

  const anchorBlockWidth = anchorDesignAdapter.blockWidth
  const anchorBlockHeight = anchorDesignAdapter.blockHeight
  const anchorBlockThickness = anchorDesignAdapter.concrete.concreteThickness
  const scale1 = getScale(anchorBlockWidth, anchorBlockHeight, canvasRect)
  const scale2 = getScale(anchorBlockWidth, anchorBlockThickness, canvasRect)
  const scale = Math.min(scale1, scale2)
  
  const leftEdge = anchorDesignAdapter.geometry.leftEdge

  var st = paper.set()
  
  // draw the block
  st.push(paper.rect(0, 0, anchorBlockWidth * scale, anchorBlockThickness * scale).attr("stroke-width", 3),)

  //draw the bolts
  const colSpacing = anchorDesignAdapter.geometry.columnSpacing
  const embedDepth = anchorDesignAdapter.boltAndNut.embedDepth
  const boltDiameter = anchorDesignAdapter.boltAndNut.boltDiameter
  for (let column = 0; column < anchorDesignAdapter.geometry.nColumns; column++) {
    let r = paper.rect(column * colSpacing * scale - boltDiameter * 0.5 * scale,
      0, boltDiameter * scale, embedDepth * scale).translate(leftEdge * scale, 0)
    r.attr("stroke-width", 3),
    st.push(r)
  }

  // width label
  let x1 = 0
  let y1 = anchorBlockThickness * scale + 10 
  let x2 = anchorBlockWidth * scale 
  let y2 = y1
  st.push(drawHorizontalDoubleArrow(x1, y1, x2, y2, 10, paper))
  let str = `${anchorBlockWidth} in`  
  st.push(drawLabelForHorizontalDimension(str, x1, x2, y1, 12, paper))

  // thickness label
  x1 = -10
  x2 = x1
  y1 = 0
  y2 = anchorBlockThickness * scale 
  st.push(drawVerticalDoubleArrow(x1, y1, x2, y2, 10, paper))
  str = `${anchorBlockThickness} in`  
  st.push(drawLabelForVerticalDimension(str, x1, y1, y2, 'left', 12, paper))
  
  // column spacing label
  if(anchorDesignAdapter.geometry.nColumns > 1) {
    let x1 = (anchorDesignAdapter.geometry.leftEdge) * scale
    let y1 = anchorDesignAdapter.boltAndNut.embedDepth * scale + 10
    let x2 = x1 + anchorDesignAdapter.geometry.columnSpacing * scale
    let y2 = y1
    st.push(drawHorizontalDoubleArrow(x1, y1, x2, y2, 10, paper))
    str = `${anchorDesignAdapter.geometry.columnSpacing} in`  
    st.push(drawLabelForHorizontalDimension(str, x1, x2, y1, 12, paper))
  }

  // embed depth label
  x1 = (leftEdge - boltDiameter) * scale - 10
  x2 = x1
  y1 = 0
  y2 = anchorDesignAdapter.boltAndNut.embedDepth * scale   
  st.push(drawVerticalDoubleArrow(x1, y1, x2, y2, 10, paper))
  str = `${anchorDesignAdapter.boltAndNut.embedDepth} in`  
  st.push(drawLabelForVerticalDimension(str, x1, y1, y2, 'left', 12, paper))

  // width label

  const center = [canvasRect[0] * 0.5, canvasRect[1] * 0.5]
  const blockLeftEdge = center[0] - anchorBlockWidth * scale * 0.5
  const blockTopEdge = center[1] - anchorBlockThickness * scale * 0.5

  st.translate(blockLeftEdge, blockTopEdge)
}

function getScale(modelWidth, modelHeight, paperRect) {
  const anchorBlockWidth = modelWidth //200
  const anchorBlockHeight = modelHeight //200

  // we want the model to fit in the canvas. we scale it so that it is 
  // either x% the width or x% the height depending on the aspect ratio
  // if w > h -> aspect w/h > 1.0 fit the model to the height
  // if w < h -> aspect w/h < 1.0 fit the model to the width

  const paperAspect = paperRect[0] / paperRect[1]
  const modelAspect = anchorBlockWidth / anchorBlockHeight

  if(paperAspect > 1.0 && modelAspect > 1.0) { return paperRect[0] / anchorBlockWidth * 0.80 }
  if(paperAspect < 1.0 && modelAspect > 1.0) { return paperRect[0] / anchorBlockWidth * 0.80 }
  if(paperAspect > 1.0 && modelAspect < 1.0) { return paperRect[1] / anchorBlockHeight * 0.80 }
  if(paperAspect < 1.0 && modelAspect < 1.0) { return paperRect[1] / anchorBlockHeight * 0.80 }
  return paperAspect < 1.0 ? paperRect[0] / anchorBlockWidth * 0.80 : paperRect[1] / anchorBlockHeight * 0.80
}

function pathM( x, y ) {return " M " + x + " " + y + " "; }

function pathL( x, y ) {return " L " + x + " " + y + " "; }

function drawHorizontalDoubleArrow(x1, y1, x2, y2, headSize, paper) {
    var halfTick = parseInt( headSize * 0.5 );
    var quarterTick = parseInt( headSize * 0.25 );
    var pathStr = pathM( x1 + halfTick, y1 - quarterTick );
    pathStr += pathL( x1, y1 );
    pathStr += pathL( x1 + halfTick, y1 + quarterTick);
    pathStr += pathM(x1, y1);
    pathStr += pathL(x2, y2);
    pathStr += pathL(x2 - halfTick, y2 - quarterTick);
    pathStr += pathM(x2, y2);
    pathStr += pathL(x2 - halfTick, y2 + quarterTick);
    var p = paper.path(pathStr);
    return p;
}

function drawVerticalDoubleArrow(x1, y1, x2, y2, headSize, paper) {
  var halfTick = parseInt( headSize * 0.5 );
  var quarterTick = parseInt( headSize * 0.25 );
  var pathStr = pathM( x1 - quarterTick, y1 + halfTick );
  pathStr += pathL( x1, y1 );
  pathStr += pathL( x1 + quarterTick, y1 + halfTick);
  pathStr += pathM(x1, y1);
  pathStr += pathL(x2, y2);
  pathStr += pathL(x2 - quarterTick, y2 - halfTick);
  pathStr += pathM(x2, y2);
  pathStr += pathL(x2 + quarterTick, y2 - halfTick);
  var p = paper.path(pathStr);
  return p;
}

function drawDiameterArrow(x, y, size, paper) {
  let pathStr = pathM(x, y)
  pathStr += pathL(x + size, y - size * 2)
  pathStr += pathL(x + size + size, y - size * 2)
  return paper.path(pathStr)
}

function renderedTextBoundingBox(string, fontSize) {
  var paper = Raphael(0, 0, 0, 0);
  paper.canvas.style.visibility = 'hidden';

  var el = paper.text(0, 0, string);
  el.attr('font-size', fontSize);

  var bBox = el.getBBox();
  paper.remove();

  return {
      width: bBox.width,
      height: bBox.height
  };
}

function drawLabelForHorizontalDimension(textStr, x1, x2, y, fontSize, paper) {
  const textBBox = renderedTextBoundingBox(textStr, fontSize) 
  const st = paper.set()
  const xMid = Math.abs(x2 - x1) * 0.5
  const xStart = x1 + xMid
  let yStart = y
  if(textBBox.width > x2 - x1 - 20) {
    yStart += fontSize
  }
  const r = paper.rect(xStart - textBBox.width * 0.5 - 2, yStart, textBBox.width + 4, textBBox.height)
  r.attr("fill", "#ffffff")
  r.attr("stroke", "#ffffff")
  st.push(r)
  const l = paper.text(xStart, yStart, textStr);
  l.attr("font-size", fontSize)
  st.push(l)
  return st
}

function drawLabelForVerticalDimension(textStr, x, y1, y2, sideOfLine, fontSize, paper) {
  const textBBox = renderedTextBoundingBox(textStr, fontSize)
  const st = paper.set()
  const yMid = Math.abs(y2 - y1) * 0.5
  let xOffset = 0
  if(sideOfLine === 'left') {
    xOffset = -textBBox.width * 0.5 - 4
  } else if(sideOfLine ==='right') {
    xOffset = textBBox.width * 0.5 + 4
  }
  let xStart = x + xOffset 
  let yStart = y1 + yMid - fontSize * 0.5
  const r = paper.rect(xStart - textBBox.width * 0.5 - 2, yStart, textBBox.width + 4, textBBox.height)
  r.attr("fill", "#ffffff")
  r.attr("stroke", "#ffffff")
  st.push(r)
  const l = paper.text(xStart, y1 + yMid, textStr);
  l.attr("font-size", fontSize)
  st.push(l)
  return st
}

function drawLabelForDiameterDimension(textStr, x, y, dimSize, fontSize, paper) {
  const textBBox = renderedTextBoundingBox(textStr, fontSize)
  const x1 = x + dimSize + dimSize + 4 + textBBox.width * 0.5
  const y1 = y - dimSize * 2
  const l = paper.text(x1, y1, textStr);
  l.attr("font-size", fontSize)
  return l
}